import Menu from '~/src/common/components/Menu';
import { type Navigation } from '~/src/common/components/Navigation/types';

import { getSubcategoryAnchorLink } from '../utils';

type Props = {
  navigation: Navigation;
  isActiveID: (id: string) => boolean;
  onLinkClick: (id: string) => void;
};

const CategoryMenuRecipes = ({ navigation, isActiveID, onLinkClick }: Props) => {
  // Tracking sur les sous-catégories recettes
  const handleSubcategoryClick = (item: { id: string }) => {
    onLinkClick(item.id);
  };

  return (
    <>
      <Menu $mobile="primary" $desktop="primary" $visibility="desktop">
        <Menu.Title>{navigation.recipe.name}</Menu.Title>
      </Menu>
      <Menu $mobile="primary" $desktop="secondary">
        {navigation.recipe.children.map(sub => (
          <Menu.Entry
            key={sub.id}
            isActive={isActiveID(sub.id)}
            onClick={() => handleSubcategoryClick(sub)}
            href={getSubcategoryAnchorLink(navigation.recipe, sub)}>
            {sub.name}
          </Menu.Entry>
        ))}
      </Menu>
    </>
  );
};

export default CategoryMenuRecipes;
